import { DateTypeModel } from './datetype.model';

export class ValidityModel {
    public typeCode:string;
    public typeName:string;
    public dateType: DateTypeModel[];
}